/** An agent's page — the one its customers sign in to, at the agent's own id — in the consumer app
    (consumer/), on its own origin. Unset only in local dev, where the consumer app runs on its
    dev port (consumer/vite.config.ts); the image build refuses to run without it. */
const CONSUMER_URL = process.env.REACT_APP_CONSUMER_URL || "http://localhost:3002";

export const clientAppLink = (agentId: string) => `${CONSUMER_URL}/a/${agentId}`;

/** The consumer app's front page, the agent marketplace: where "Use agents" goes. */
export const MARKETPLACE_URL = CONSUMER_URL;
